import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { useMemo, useState } from 'react';
import { useAccountsUser } from '../../AdminCenter/views/WorkspaceTeamsView/hooks/useAccountsUser';

export const useAccountSuggestions = (excluded?: string[]) => {
  const [query, setQuery] = useState('');

  const [workspaceId] = useCurrentWorkspace();
  const { resources: suggestedAccounts, loading: loadingAccounts } =
    useResourceList__ALPHA({
      resourceType: 'workspace',
      resourceId: workspaceId,
      edgeType: 'account',
      edgeLabel: 'accounts',
      params: useMemo(() => {
        return query
          ? {
              filter: {
                search: query.trim()
              }
            }
          : undefined;
      }, [query])
    });

  const { resources: suggestedAccountsWithNames, loading: retrievingUsers } =
    useAccountsUser(suggestedAccounts);

  const [excludedAccounts /*filteredAccounts*/] = useMemo(() => {
    if (!suggestedAccountsWithNames || !excluded) {
      return [[], []];
    }

    const include = suggestedAccountsWithNames.map(
      (acc) => excluded.indexOf(acc.id) < 0
    );
    return [
      suggestedAccountsWithNames.filter((val, idx) => !include[idx]),
      suggestedAccountsWithNames.filter((val, idx) => include[idx])
    ];
  }, [suggestedAccountsWithNames, excluded]);

  return {
    query,
    setQuery,
    suggestedAccounts: suggestedAccountsWithNames,
    excludedAccounts,
    loading: retrievingUsers || loadingAccounts
  };
};
